import { Button } from '@/components/form/Button';
import { ButtonVariant } from '@/components/form/buttonHelper';
import { LogoField } from '@/components/form/fields/image/LogoInput';
import { Modal } from '@/components/modal/Modal';
import { ModalProps } from '@/components/modal/useModal';
import { Card } from '@/components/sections/Card';

import { FunctionComponent } from 'react';
import { useFormContext } from 'react-hook-form';
import checker from '../../../../assets/checker.png';

const UploadMspLogoModal: FunctionComponent<
  ModalProps<{ onConfirmCallback: (logo: File) => void | Promise<void> }>
> = props => {
  const onSubmit = async () => {
    await props.props?.onConfirmCallback(logo);
    props.close();
  };

  const { watch } = useFormContext();

  const logo = watch('logo');

  return (
    <Modal className="md:max-w-xl" {...props}>
      <Card className="w-full p-8">
        <Modal.Controls {...props}>
          <h1 className="text-2xl font-semibold">Create new MSP</h1>
        </Modal.Controls>
        <div className="flex flex-1 flex-col space-y-4">
          <div className="flex justify-between space-x-10">
            <div className="flex-1 space-y-1">
              <p className="text-lg font-semibold">Do:</p>
              <div
                className="w-full h-10 border rounded-md border-green-500 p-0.5"
                style={{
                  background: `url(${checker}), lightgray 0% 0% / 20px 20px repeat`
                }}
              >
                <div className="w-full h-full bg-gray-700 rounded-full"></div>
              </div>
              <ul className="pl-5 text-sm font-semibold list-disc">
                <li>Scale your logo to cover the whole image</li>
                <li>Have a transparent background</li>
                <li>Logo dimensions around 1500 x 350</li>
              </ul>
            </div>
            <div className="flex-1 space-y-1">
              <p className="text-lg font-semibold">Don't:</p>
              <div className="w-full h-10 border rounded-md border-red-500 p-1">
                <div className="w-full h-full bg-[#e5e5e5] p-2">
                  <div className="w-full h-full bg-gray-700 rounded-full"></div>
                </div>
              </div>
              <ul className="pl-5 text-sm font-semibold list-disc">
                <li>Include space around your logo</li>
                <li>Include a solid background</li>
              </ul>
            </div>
          </div>
          <div className="mt-4 flex h-full w-full flex-1 flex-col">
            <LogoField id="logo" />
          </div>

          <div className="flex justify-end pt-2">
            <Button disabled={!logo} onClick={onSubmit} className="w-fit" variant={ButtonVariant.Primary} type="button">
              Confirm
            </Button>
          </div>
        </div>
      </Card>
    </Modal>
  );
};

export default UploadMspLogoModal;
